import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import GetParams from "../../utils/getParams";
import LoadingIcon from "../Loading/LoadingIcon";
import GAMEITEM from "../GAMEITEM/GAMEITEM";
import { RiArrowDownSLine } from "react-icons/ri";
import { Button } from "semantic-ui-react";

const Games = ({
  defaultPlatform,
  platformType,
  allGame,
  specialColor,
  sort,
  platform,
}) => {
  // const platform = GetParams("platform");

  const gameList = useSelector((state) => state.isGameList);
  const { t } = useTranslation();
  const i18n = (key) => t(`gamePage.${key}`);

  const sortGames = (games) => {
    if (sort === "A - Z") {
      return games?.sort((a, b) => a.ename.localeCompare(b.ename)) ?? [];
    } else if (sort === "7Days") {
      return (
        games?.sort((a, b) => Number(a.sevenCounts) - Number(b.sevenCounts)) ??
        []
      );
    } else if (sort === "30Days") {
      return (
        games?.sort(
          (a, b) => Number(a.thirtyCounts) - Number(b.thirtyCounts)
        ) ?? []
      );
    } else if (sort === "totalDays") {
      return (
        games?.sort((a, b) => Number(a.totalCounts) - Number(b.totalCounts)) ??
        []
      );
    } else {
      return games;
    }
  };

  const games = useMemo(() => {
    if (!platform) {
      return sortGames(allGame);
    }

    return sortGames(gameList?.[platform]?.[platformType]);
  }, [gameList, platform, sort, allGame]);

  const [more, setMore] = useState(30);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setMore(30);
    if (more >= games?.length) {
      setMore(games?.length);
    } else if (more < 30) {
      setMore(30);
    }
  }, [platform, games]);

  const handleMoreGame = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (more < games?.length) {
        setIsLoading(false);
        setMore((prev) => Math.min(prev + 30, games?.length));
      }
    }, 500);
  };

  return (
    <section>
      <section className="grid md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-7 grid-cols-3 gap-[15px] mb-[15px]">
        {games?.slice(0, more)?.map((item, index) => {
          const en_Name = item?.ename;
          const zh_Name = item?.cname;
          const platform = item?.platform;
          const gameCode = item?.gameCode;
          const gameType = item?.gameType;
          return (
            <section className="flex flex-col ">
              <GAMEITEM
                itemClass={"!h-[190px]"}
                index={index}
                specialColor={specialColor}
                hasBottomTitle
                gameProps={{ en_Name, zh_Name, platform, gameCode, gameType }}
              />
            </section>
          );
        })}
      </section>
      <p className="text-main-color text-center text-xl font-semibold">
        {more}/{games?.length} {i18n("games")}
      </p>
      {more >= games?.length || (
        <LoadingIcon commonLoading={isLoading} size="medium">
          <section
            onClick={handleMoreGame}
            className="flex flex-col items-center justify-center text-main-color mt-[10px] cursor-pointer"
          >
            <Button className="mb-[1px] !bg-main-color !text-light-white">
              {i18n("showMore")}
            </Button>
          </section>
        </LoadingIcon>
      )}
    </section>
  );
};

export default Games;
